import React, { Component } from 'react'
import axios from 'axios'
import { withTranslation } from 'react-i18next'
import querystring from 'query-string'
import Cookie from '../../utils/Cookie'

import './Login.scss'

class Login extends Component {
    state = {
        username: '',
        password: '',
        settings: null,
        hasLoginError: false,
        unauthorized: false,
        hasAuthenticationCookie: false
    }

    UNSAFE_componentWillMount = () => {
        this.lastRequest = new Date().getTime();
        axios.interceptors.request.use(
            request => {
                this.lastRequest = new Date().getTime();
                return request;
            }
        )

        var authenticationCookie = Cookie.getAuthenticationCookie()
        if (authenticationCookie) {
            var tokenInfo = JSON.parse(authenticationCookie)
            this.setState({hasAuthenticationCookie: true})
            this.assignToken(tokenInfo)
        }
    }

    disableSubmit = event => {
        event.preventDefault()
        return false
    }

    onUsernameChange = event => {
        this.setState({username: event.target.value});
    }

    onPasswordChange = event => {
        this.setState({password: event.target.value});
    }

    onLogin = () => {
        this.setState({hasLoginError: false})
        this.refreshToken();
    }

    refreshToken() {
        var expirationInMinutes = 60;

        var inactivityTimeInMinutes = (new Date().getTime() - this.lastRequest)/60000;
        if (this.state.hasAuthenticationCookie || inactivityTimeInMinutes > expirationInMinutes-2) {
            Cookie.removeAuthenticationCookie()
            window.location.reload();
            return;
        }

        var body = querystring.stringify({
            request: 'getToken',
            username: this.state.username,
            password: this.state.password,
            expiration: expirationInMinutes,
            f: 'json'
        });
        var headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        axios.post("https://services.geodataonline.no/arcgis/tokens/", body, headers)
            .then(response => {
                if (response.data.error) {
                    this.setState({ hasLoginError: true });
                    return;
                }

                var tokenInfo = {
                    username: this.state.username,
                    created: response.data.expires - (60000 * expirationInMinutes),
                    expires: response.data.expires,
                    token: response.data.token
                };

                Cookie.setAuthenticationCookie(tokenInfo, expirationInMinutes - 1)

                this.assignToken(tokenInfo)
            });
    }

    assignToken = (tokenInfo)  => {
        if (this.state.settings) {
            this.props.onTokenChanged(tokenInfo, this.state.settings)
            var refreshTokenInMilliseconds = tokenInfo.expires - tokenInfo.created - 60000
            setTimeout(() => {
                this.refreshToken()
            }, refreshTokenInMilliseconds)
        }
        else {
            var baseUrl = window.location.pathname
            if (window.location.hostname == "localhost")
                baseUrl = "https://test.geoeiendom.no/"
            axios.get(`${baseUrl}api/settings`, {
                params: {
                    token: tokenInfo.token
                }
            })
                .then(response => {
                    this.setState({ settings: response.data })
                    this.props.onTokenChanged(tokenInfo, response.data)
                    var refreshTokenInMilliseconds = tokenInfo.expires - tokenInfo.created - 60000
                    setTimeout(() => {
                        this.refreshToken()
                    }, refreshTokenInMilliseconds)
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        this.setState({ unauthorized: true })
                    }
                    else {
                        this.setState({ hasLoginError: true })
                        console.log("Error", error.message)
                    }
                })
        }
    }

    render() {
        if (this.state.hasAuthenticationCookie) return (null)
        const { t } = this.props
        return (
            <div className="login">
                <div className="login-content">
                    <p>{t('logginn.beskrivelse')}</p>
                    <form onSubmit={this.disableSubmit}>
                        <div>
                            <label htmlFor="username">{t('logginn.brukernavn')}</label>
                            <input id="username" type="text" autoComplete="username" value={this.state.username} onChange={this.onUsernameChange} />

                            <label htmlFor="password">{t('logginn.passord')}</label>
                            <input id="password" type="password" autoComplete="current-password" value={this.state.password} onChange={this.onPasswordChange} />

                            <button onClick={this.onLogin}>{t('logginn.neste')}</button>
                            <a href="https://www.geodata.no/artikkel/glemt-passord-til-geodata-online" target="_blank">{t('logginn.glemtpassord')}</a>
                        </div>
                    </form>
                    <div className="error">
                        {this.state.hasLoginError && <div>{t('logginn.feil')}</div>}
                        {this.state.unauthorized && <div>{t('logginn.ikketilgang')}</div>}
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation('common')(Login)